import { difference } from '@openx/components-form/difference';
import type { AllQueryCriteria } from '@openx/types/criteriaExtractors';
import { type AllTableCriteria, SortDirection } from '@openx/types/tableCriteria';
import { defaultCriteria } from '../PackagesList/constants';

export const getInitialCriteria = (searchParams: URLSearchParams) => {
  const initialCriteria = structuredClone(defaultCriteria);

  const column = searchParams.get('column');
  const sortDirection = searchParams.get('sortDirection');
  const phrase = searchParams.get('phrase');
  const pageNumber = searchParams.get('page');
  const adPlacement = searchParams.get('ad_placement');

  if (column) {
    initialCriteria.sort.column = column;
  }

  if (sortDirection) {
    initialCriteria.sort.direction = sortDirection === SortDirection.DESC ? SortDirection.DESC : SortDirection.ASC;
  }

  if (phrase) {
    initialCriteria.filters.phrase = phrase;
  }

  if (adPlacement) {
    initialCriteria.filters.ad_placement = adPlacement;
  }

  const account_uids = searchParams.getAll('account_uid');

  if (account_uids.length) {
    initialCriteria.filters.account_uid = account_uids;
  }

  if (pageNumber) {
    initialCriteria.pagination.pageNumber = parseInt(pageNumber, 10);
  }

  return initialCriteria;
};

export function convertCriteriaToSearchParams(
  criteria: AllTableCriteria,
  defaultCriteria: AllQueryCriteria
): URLSearchParams {
  const diff = difference(criteria, defaultCriteria);
  const searchParams = new URLSearchParams();

  if (diff.sort?.column) {
    searchParams.append('column', diff.sort.column);
  }

  if (diff.sort?.direction) {
    searchParams.append('sortDirection', diff.sort.direction);
  }

  if (diff.pagination?.pageNumber) {
    searchParams.append('page', diff.pagination.pageNumber.toString());
  }

  if (diff.filters?.phrase) {
    searchParams.append('phrase', diff.filters.phrase);
  }

  if (typeof diff.filters?.ad_placement === 'string') {
    searchParams.append('ad_placement', diff.filters.ad_placement);
  }

  for (const uid of diff.filters?.account_uid ?? []) {
    searchParams.append('account_uid', uid);
  }

  return searchParams;
}
